/*!
 * © 2026 Soulcute / Tailoring Consult — Todos los derechos reservados.
 * Bundle 3X2 Builder — selector cross-product (ARMA TU PACK)
 */
(function(){
  var el = document.getElementById('sc-b3xb');
  if (!el) return;
  var dataEl = document.getElementById('sc-b3xb-data');
  if (!dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch(e) { console.error('[b3xb] data parse', e); return; }

  /* slots[i] = { productHandle, variantId, productTitle, variantTitle, image, price } */
  var slots = [null, null, null];
  var ctaBtn = document.getElementById('sc-b3xb-cta');
  var hintEl = document.getElementById('sc-b3xb-hint');
  var totalEl = document.getElementById('sc-b3xb-total');
  var savedEl = document.getElementById('sc-b3xb-saved');
  var modal = document.getElementById('sc-b3xb-modal');
  var modalBody = document.getElementById('sc-b3xb-modal-body');
  var modalTitle = document.getElementById('sc-b3xb-modal-title');
  var modalClose = document.getElementById('sc-b3xb-modal-close');
  var currentSlotIndex = null;

  function fmt(cents){ return '$' + Math.round(cents).toLocaleString('es-CL'); }

  function getProductByHandle(h){ return D.products.find(function(p){ return p.handle === h; }); }
  function getVariantById(prod, vid){ return prod.variants.find(function(v){ return v.id === vid; }); }
  function findVariantByOptions(prod, opts){
    return prod.variants.find(function(v){
      if (v.options.length !== opts.length) return false;
      return v.options.every(function(o, i){ return o === opts[i]; });
    });
  }

  /* === RENDER SLOTS === */
  function renderSlots(){
    /* Encontrar el más barato entre los slots llenos */
    var prices = slots.map(function(s){ return s ? s.price : Infinity; });
    var minPrice = Math.min.apply(null, prices);
    var cheapestIdx = -1;
    if (slots.filter(function(s){ return s !== null; }).length === 3) {
      cheapestIdx = prices.indexOf(minPrice);
    }

    slots.forEach(function(slot, idx){
      var slotEl = el.querySelector('[data-slot="'+(idx+1)+'"]');
      if (!slotEl) return;
      slotEl.classList.toggle('is-filled', slot !== null);
      slotEl.classList.toggle('is-cheapest', idx === cheapestIdx);

      if (slot) {
        slotEl.innerHTML =
          '<div class="sc-b3xb__slot-img">' +
            '<img src="' + slot.image + '" alt="">' +
            '<span class="sc-b3xb__slot-num">' + (idx+1) + '/3</span>' +
          '</div>' +
          '<div class="sc-b3xb__slot-info">' +
            '<div class="sc-b3xb__slot-title">' + slot.productTitle + '</div>' +
            '<div class="sc-b3xb__slot-variant">' + slot.variantTitle + '</div>' +
            '<div class="sc-b3xb__slot-price">' +
              (idx === cheapestIdx ? '<s>' + fmt(slot.price/100) + '</s> $0' : fmt(slot.price/100)) +
            '</div>' +
          '</div>' +
          '<button type="button" class="sc-b3xb__edit" data-slot-action="'+(idx+1)+'">Cambiar</button>';
      } else {
        slotEl.innerHTML =
          '<div class="sc-b3xb__slot-img sc-b3xb__slot-img--empty">' +
            '<span class="sc-b3xb__slot-3x2">3X2</span>' +
            '<span class="sc-b3xb__slot-num">' + (idx+1) + '/3</span>' +
          '</div>' +
          '<button type="button" class="sc-b3xb__select" data-slot-action="'+(idx+1)+'">+ Selecciona tu body</button>';
      }
    });

    updateTotals(cheapestIdx);
    updateCtaState();
  }

  function updateTotals(cheapestIdx){
    var sumGross = 0, sumPay = 0;
    slots.forEach(function(s, i){
      if (!s) return;
      sumGross += s.price;
      if (i !== cheapestIdx) sumPay += s.price;
    });
    totalEl.textContent = fmt(sumPay/100);
    savedEl.textContent = 'Ahorras: ' + fmt((sumGross - sumPay)/100);
  }

  function updateCtaState(){
    var filled = slots.filter(function(s){ return s !== null; }).length;
    var missing = 3 - filled;
    if (missing === 0) {
      ctaBtn.disabled = false;
      hintEl.classList.add('is-ready');
      hintEl.innerHTML = '&#10003; Listo para agregar al carrito';
    } else {
      ctaBtn.disabled = true;
      hintEl.classList.remove('is-ready');
      hintEl.innerHTML = 'Falta elegir <span>' + missing + '</span> body(s)';
    }
  }

  /* === MODAL: catálogo de bodys con selector de variante por producto === */
  function openModal(slotIdx){
    currentSlotIndex = slotIdx;
    modalTitle.textContent = 'Elige tu body ' + (slotIdx+1) + '/3';
    /* Estado de selección por producto en el modal */
    modal._selOpts = {};  /* { productId: [opt1, opt2, ...] } */
    renderModalCatalog();
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeModal(){
    modal.hidden = true;
    currentSlotIndex = null;
    document.body.style.overflow = '';
  }

  function renderModalCatalog(){
    /* IDs ya usados en otros slots (no permitir re-elegir mismo producto+variant) */
    var usedVariantIds = slots.map(function(s, i){ return (s && i !== currentSlotIndex) ? s.variantId : null; }).filter(Boolean);

    var html = '';
    D.products.forEach(function(p){
      /* skip productos sin variantes disponibles */
      var anyAvail = p.variants.some(function(v){ return v.available && usedVariantIds.indexOf(v.id) < 0; });
      if (!anyAvail) return;

      var selOpts = modal._selOpts[p.id] || new Array(p.options.length).fill(null);

      html += '<div class="sc-b3xb__pitem" data-pid="'+p.id+'">';
      html += '<div class="sc-b3xb__pitem-img"><img src="'+p.image+'" alt=""></div>';
      html += '<div class="sc-b3xb__pitem-info">';
      html += '<div class="sc-b3xb__pitem-title">'+p.title+'</div>';
      html += '<div class="sc-b3xb__pitem-price">'+fmt(p.minPrice/100)+'</div>';
      html += '<div class="sc-b3xb__pitem-opts">';
      p.options.forEach(function(opt, optIdx){
        html += '<div class="sc-b3xb__pitem-optgroup">';
        html += '<span class="sc-b3xb__pitem-optlabel">'+opt.name+':</span>';
        opt.values.forEach(function(val){
          var compatible = p.variants.some(function(v){
            if (!v.available || usedVariantIds.indexOf(v.id) >= 0) return false;
            if (v.options[optIdx] !== val) return false;
            for (var i=0; i<selOpts.length; i++){
              if (i !== optIdx && selOpts[i] !== null && v.options[i] !== selOpts[i]) return false;
            }
            return true;
          });
          var isSel = selOpts[optIdx] === val;
          html += '<button type="button" class="sc-b3xb__pitem-opt'+(isSel?' is-selected':'')+'" data-pid="'+p.id+'" data-opt-idx="'+optIdx+'" data-opt-val="'+val+'"'+(compatible?'':' disabled')+'>'+val+'</button>';
        });
        html += '</div>';
      });
      html += '</div>';
      html += '</div>';
      /* Botón Elegir */
      var pickedVid = null;
      if (selOpts.every(function(s){ return s !== null; })) {
        var v = findVariantByOptions(p, selOpts);
        if (v && v.available && usedVariantIds.indexOf(v.id) < 0) pickedVid = v.id;
      }
      html += '<button type="button" class="sc-b3xb__pitem-add" data-pick-pid="'+p.id+'"'+(pickedVid?'':' disabled')+'>Elegir</button>';
      html += '</div>';
    });
    modalBody.innerHTML = html;

    /* Wire option buttons */
    modalBody.querySelectorAll('.sc-b3xb__pitem-opt').forEach(function(btn){
      btn.addEventListener('click', function(){
        if (btn.disabled) return;
        var pid = parseInt(btn.dataset.pid);
        var idx = parseInt(btn.dataset.optIdx);
        var val = btn.dataset.optVal;
        var sel = modal._selOpts[pid] || new Array(D.products.find(function(p){return p.id===pid;}).options.length).fill(null);
        sel[idx] = val;
        modal._selOpts[pid] = sel;
        renderModalCatalog();
      });
    });

    /* Wire "Elegir" buttons */
    modalBody.querySelectorAll('.sc-b3xb__pitem-add').forEach(function(btn){
      btn.addEventListener('click', function(){
        if (btn.disabled) return;
        var pid = parseInt(btn.dataset.pickPid);
        var p = D.products.find(function(prod){ return prod.id === pid; });
        var sel = modal._selOpts[pid];
        if (!p || !sel) return;
        var v = findVariantByOptions(p, sel);
        if (!v || !v.available) return;
        slots[currentSlotIndex] = {
          productHandle: p.handle,
          productTitle: p.title,
          variantId: v.id,
          variantTitle: v.title,
          image: v.image || p.image,
          price: v.price
        };
        closeModal();
        renderSlots();
      });
    });
  }

  /* === HOOKS === */
  el.addEventListener('click', function(e){
    var t = e.target.closest('[data-slot-action]');
    if (!t) return;
    var idx = parseInt(t.dataset.slotAction) - 1;
    openModal(idx);
  });

  modalClose.addEventListener('click', closeModal);
  modal.addEventListener('click', function(e){ if (e.target === modal) closeModal(); });

  ctaBtn.addEventListener('click', function(){
    if (ctaBtn.disabled) return;
    var items = slots.map(function(s){
      return { id: s.variantId, quantity: 1, properties: { '_sc_3x2_builder': 'true' } };
    });
    ctaBtn.disabled = true;
    var origText = ctaBtn.innerHTML;
    ctaBtn.innerHTML = 'AGREGANDO...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items })
    })
      .then(function(r){ return r.json(); })
      .then(function(resp){
        if (resp.status && resp.status >= 400) throw new Error(resp.description || 'Error');
        ctaBtn.innerHTML = '&#10003; AGREGADO';
        setTimeout(function(){
          if (window.scOpenCartDrawer) { scOpenCartDrawer(); }
          else { window.location.href = '/cart'; }
        }, 600);
      })
      .catch(function(err){
        console.error('[b3xb] add err', err);
        ctaBtn.innerHTML = '&#9888; ERROR';
        setTimeout(function(){ ctaBtn.innerHTML = origText; ctaBtn.disabled = false; }, 2500);
      });
  });

  /* Init */
  renderSlots();
})();
